// Helper function to get correct image path for both local and production
const getImagePath = (path) => {
  return `${process.env.PUBLIC_URL}${path}`;
};

export const servicesCardData = {
  'Casting Crew': [
    {
      id: 'actor-1',
      name: 'Auto Nagaraj',
      title: 'Professional Actor',
      image: getImagePath('/assets/Actors/Auto nagaraj.jpg'),
      location: 'Los Angeles, CA',
      experience: '12+ Years',
      rating: 4.9,
      reviews: 156,
      portfolio: [
        getImagePath('/assets/Actors/Auto nagaraj.jpg'),
        ],
      specialties: ['Drama', 'Action', 'Commercial'],
      email: 'autonagaraj@gmail.com',
      phone: '+91 9071709216',
      bio: 'Versatile actor with extensive experience in film, television, and commercial productions. Known for dynamic performances and professional work ethic.'
    },
    {
      id: 'actor-2',
      name: 'Baba saheb',
      title: 'Film & TV Actor',
      image: getImagePath('/assets/Actors/Baba_saheb.jpg'),
      location: 'New York, NY',
      experience: '10+ Years',
      rating: 4.8,
      reviews: 203,
      portfolio: [
        getImagePath('/assets/Actors/Baba saheb1.jpg'),
        getImagePath('/assets/Actors/Baba saheb2.jpg'),
        getImagePath('/assets/Actors/Baba saheb3.jpg'),
      ],
      specialties: ['Comedy', 'Romance', 'Drama'],
      email: 'babasaheb@gmail.com',
      phone: '+91 8073080390',
      bio: 'Talented actress specializing in character-driven roles across film and television. Brings authenticity and depth to every performance.'
    },
    {
      id: 'actor-3',
      name: 'Basu adrushi',
      title: 'Theater & Screen Actor',
      image: getImagePath('/assets/Actors/Basu adrushi.jpg'),
      location: 'Chicago, IL',
      experience: '15+ Years',
      rating: 5.0,
      reviews: 89,
      portfolio: [
        getImagePath('/assets/Actors/Basu adrushi.jpg'),
      ],
      specialties: ['Theater', 'Film', 'Voice Acting'],
      email: 'basuadrushi@gmail.com',
      phone: '+91 9886900048',
      bio: 'Classically trained actor with a strong background in theater and extensive screen experience. Known for powerful performances and vocal versatility.'
    },
    {
      id: 'actor-4',
      name: 'Chaitan namdev',
      title: 'Commercial & Film Actor',
      image: getImagePath('/assets/Actors/Chaitan namdev.jpg'),
      location: 'Miami, FL',
      experience: '8+ Years',
      rating: 4.7,
      reviews: 134,
      portfolio: [
        getImagePath('/assets/Actors/Chaitan namdev.jpg'),
      ],
      specialties: ['Commercial', 'Fashion', 'Lifestyle'],
      email: 'chaitannamdev@gmail.com',
      phone: '+91 0090988909',
      bio: 'Dynamic actor with a strong presence in commercial and fashion productions. Brings energy and professionalism to every project.'
    },
    {
      id: 'actor-5',
      name: 'CTO Srinivas',
      title: 'Action & Drama Actor',
      image: getImagePath('/assets/Actors/CTO srinivaas.jpg'),
      location: 'San Francisco, CA',
      experience: '9+ Years',
      rating: 4.8,
      reviews: 178,
      portfolio: [
        getImagePath('/assets/Actors/CTO srinivaas.jpg'),
      ],
      specialties: ['Action', 'Thriller', 'Drama'],
      email: 'ctosrinivas@gmail.com',
      phone: '91 7795758465',
      bio: 'Skilled actor specializing in action and dramatic roles. Trained in martial arts and stunt work for authentic performances.'
    },
    {
      id: 'actor-6',
      name: 'Hamsaraj',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors/Hamsaraj.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
        getImagePath('/assets/Actors/Hamsaraj.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'hamsaraj@gmail.com',
      phone: '91 9845388099',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },
    {
      id: 'actor-7',
      name: 'jotiba bhujang',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors/jotiba bhujang.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors/jotiba bhujang.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'jotibabhujang@gmail.com',
      phone: '+1 (555) 666-7777',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },
    {
      id: 'actor-8',
      name: 'Lalipalya Mahadev',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors/Lalipalya Mahadevv.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors/Lalipalya Mahadevv.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'lalipalya mahadev@gmail.com',
      phone: '91 9108065259',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },
    {
      id: 'actor-9',
      name: 'Mahantesh ramdurga',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors/Mahantesh ramdurga.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors/Mahantesh ramdurga.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'mahanteshramdurga@gmail.com',
      phone: '91 9483201998',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },
    {
      id: 'actor-10',
      name:'Nagaraj kotte',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors/Nagaraj kotte.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors/Nagaraj kotte.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'nagarajkotte@gmail.com',
      phone: '91 9448106217',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },
    {
      id: 'actor-11',
      name: 'NTS',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors/NTS.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors/NTS.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'nts@gmail.com',
      phone: '91 9980760650',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },
    {
      id: 'actor-12',
      name: 'Praveen rabkavi',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors/Praveen rabkavi.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors/Praveen rabkavi.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'praveenrabkavi@gmail.com',
      phone: '91 9901852402',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },
    {
      id: 'actor-13',
      name: 'Raju nayak',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors/Raju nayak artist.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors/Raju nayak artist.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'raju nayak artist@gmail.com',
      phone: '91 8197876130',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-14',
      name: 'Sagar',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors/Sagar.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors/Sagar.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'sagar@gmail.com',
      phone: '91 9241782269',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },
    {
      id: 'actor-15',
      name: 'Surekha artiste',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors/Surekha artiste.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors/Surekha artiste.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'surekhaartiste@gmail.com',
      phone: '91 8660133522 , 91 9880469249',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-16',
      name: 'Yash nadaf',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors/Yash nadaf.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors/Yash nadaf.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'yashnadaf@gmail.com',
      phone: '91 9886610178',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-17',
      name: 'Anand',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Anand.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Anand.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'anand@gmail.com',
      phone: '91 9980319973',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },  
    {
      id: 'actor-18',
      name: 'Archana usha',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Archana usha.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Archana usha.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'archanausha@gmail.com',
      phone: '91 9845224268 ,91 7892506660',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-19',
      name: 'Archana',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Archana.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Archana.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'archana@gmail.com',
      phone: '91 8867737091',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-20',
      name: 'Athis',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Athis.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Athis.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'athis@gmail.com',
      phone: '91 9845232006',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-21',
      name: 'Bhaskar udupi',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Bhaskar udupi.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Bhaskar udupi.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'bhaskarudupi@gmail.com',
      phone: '91 9880108060',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },  
    {
      id: 'actor-22',
      name: 'Chaitan',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Chintan1.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Chintan1.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'chaitannamdev@gmail.com',
      phone: '91 6366339539',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },   
    {
      id: 'actor-23',
      name: 'Chiranjeevi',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Chiranjeevi anebala.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Chiranjeevi anebala.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'chiranjeevi anebala@gmail.com',
      phone: '91 9148616967',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },  
    {
      id: 'actor-24',
      name: 'Gowtham',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Gowtham.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Gowtham.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'gowtham@gmail.com',
      phone: '91 7411720035',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },   
    {
      id: 'actor-25',
      name: 'Gururaj Shetty',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Gururaj shetty.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Gururaj shetty.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'gururajshetty@gmail.com',
      phone: '91 8105513599 , 91 7975807474',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-26',
      name: 'Harish',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Harish.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Harish.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'harish@gmail.com',
      phone: '91 9538987548',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },     
    {
      id: 'actor-27',
      name: 'Kiran badkoli',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Kiran badkoli.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Kiran badkoli.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'kiranbadkoli@gmail.com',
      phone: '91 9035666835',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-28',
      name: 'Lakki',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Lakki.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Lakki.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'lakki@gmail.com',
      phone: '91 7349180038',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-29',
      name: 'Mallaraju',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Mallaraju.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Mallaraju.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'mallaraju@gmail.com',
      phone: '91 9964838578',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },  
    {
      id: 'actor-30',
      name: 'Mandya',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Mandya.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Mandya.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'mandya@gmail.com',
      phone: '91 9964332581',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },  
    {
      id: 'actor-31',
      name: 'Nagamma',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Nagamma.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Nagamma.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'nagamma@gmail.com',
      phone: '91 9449383117',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },   
    {
      id: 'actor-32',
      name: 'Nagendra',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Nagendra.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Nagendra.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'nagendrak@gmail.com',
      phone: '91 9844621234',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },   
    {
      id: 'actor-33',
      name: 'Nithin',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Nithin.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Nithin.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'nithin@gmail.com',
      phone: '91 9480295552',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },   
    {
      id: 'actor-34',
      name: 'Prakash',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Prakash.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Prakash.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'prakash@gmail.com',
      phone: '91 9845159089',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },  
    {
      id: 'actor-35',
      name: 'Radika',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Radika.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Radika.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'radika@gmail.com',
      phone: '91 7411711951',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },
    {
      id: 'actor-36',
      name: 'Ranjith',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Ranjith.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Ranjith.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'ranjith@gmail.com',
      phone: '91 7411341203',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
     {
      id: 'actor-37',
      name: 'Renu shrikari',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Renu shrikari.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Renu shrikari.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'renushrikari@gmail.com',
      phone: '91 9845423298',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },    
    {
      id: 'actor-38',
      name: 'Roopashree',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Roopashree.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Roopashree.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'roopashree@gmail.com',
      phone: '91 9845218399',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },   
    {
      id: 'actor-39',
      name: 'Roopa',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Roopa.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Roopa.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'roopa@gmail.com',
      phone: '91 9895167346',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },      
    {
      id: 'actor-40',
      name: 'Siddu',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Siddu kaka.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Siddu kaka.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'siddukaka@gmail.com',
      phone: '91 7899899092',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-41',
      name: 'Swadesh',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/swadesh.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/swadesh.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'swadesh@gmail.com',
      phone: '91 9945566998',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },   
    {
      id: 'actor-42',
      name: 'Umesh',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Umesh.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Umesh.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'umesh@gmail.com',
      phone: '91 9880840947',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },  
    {
      id: 'actor-43',
      name: 'Varalaxmi',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Varalakshmi.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Varalakshmi.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'varalakshmi@gmail.com',
      phone: '91 9900394999',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-44',
      name: 'Vinod Belagavi',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Vinod Belagavi.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Vinod Belagavi.jpg'),
       getImagePath('/assets/Actors 2/Vinod Belagavi1.jpg'),
       getImagePath('/assets/Actors 2/Vinod Belagavi2.jpg'),
       getImagePath('/assets/Actors 2/Vinod Belagavi3.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'vinodbelagavi@gmail.com',
      phone: '91 9900000000',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-45',
      name: 'Vishva',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Vishva.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Vishva.jpg'),
       getImagePath('/assets/Actors 2/Vishva1.jpg'),
        ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'vishva@gmail.com',
      phone: '91 8618803424',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    },  
    {
      id: 'actor-46',
      name: 'Karthik chidambaram',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Karthik chidambaram.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Karthik chidambaram.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'karthikchidambaram@gmail.com',
      phone: '91 8123255231',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }, 
    {
      id: 'actor-47',
      name: 'Jagadish janamana',
      title: 'Character Actor',
      image: getImagePath('/assets/Actors 2/Jagadish janamana.jpg'),
      location: 'Boston, MA',
      experience: '11+ Years',
      rating: 4.9,
      reviews: 245,
      portfolio: [
       getImagePath('/assets/Actors 2/Jagadish janamana.jpg'),
      ],
      specialties: ['Character Roles', 'Period Drama', 'Indie Films'],
      email: 'jagadishjanamana@gmail.com',
      phone: '91 9448602554',
      bio: 'Versatile character actor known for transformative performances. Specializes in period dramas and independent film projects.'
    }
  ],
  'Cinema Autography': [
    {
      id: 'cinema-1',
      name: 'Alex Rodriguez',
      title: 'Cinematographer',
      image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop&auto=format&q=80',
      location: 'Hollywood, CA',
      experience: '15+ Years',
      rating: 5.0,
      reviews: 89,
      portfolio: [
        'https://images.unsplash.com/photo-1440404653325-ab127d49abc1?w=800&h=600&fit=crop&auto=format&q=80',
        'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&h=600&fit=crop&auto=format&q=80',
        'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800&h=600&fit=crop&auto=format&q=80'
      ],
      specialties: ['Feature Films', 'Documentaries', 'Music Videos'],
      email: 'alex.rodriguez@cinema.com',
      phone: '+1 (555) 789-0123',
      bio: 'Award-winning cinematographer known for stunning visual storytelling in feature films and documentaries.'
    },
    {
      id: 'cinema-2',
      name: 'Maria Santos',
      title: 'Director of Photography',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&auto=format&q=80',
      location: 'New York, NY',
      experience: '12+ Years',
      rating: 4.9,
      reviews: 134,
      portfolio: [
        'https://images.unsplash.com/photo-1440404653325-ab127d49abc1?w=800&h=600&fit=crop&auto=format&q=80',
        'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&h=600&fit=crop&auto=format&q=80'
      ],
      specialties: ['Commercial', 'Short Films', 'Brand Content'],
      email: 'maria.santos@dop.com',
      phone: '+1 (555) 890-1234',
      bio: 'Creative DP specializing in commercial and brand content with a unique visual style.'
    }
  ],
  'Makeup Artists': [
    {
      id: 'makeup-1',
      name: 'Emma Thompson',
      title: 'Beauty & Special Effects Artist',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop&auto=format&q=80',
      location: 'Los Angeles, CA',
      experience: '9+ Years',
      rating: 4.9,
      reviews: 187,
      portfolio: [
        'https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=800&h=600&fit=crop&auto=format&q=80',
        'https://images.unsplash.com/photo-1583241478821-4c01f8c0e5e8?w=800&h=600&fit=crop&auto=format&q=80'
      ],
      specialties: ['Film', 'Fashion', 'Special Effects'],
      email: 'emma.thompson@makeup.com',
      phone: '+1 (555) 901-2345',
      bio: 'Talented makeup artist specializing in beauty, fashion, and special effects makeup for film and photography.'
    },
    {
      id: 'makeup-2',
      name: 'Jessica Chen',
      title: 'Celebrity Makeup Artist',
      image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop&auto=format&q=80',
      location: 'New York, NY',
      experience: '11+ Years',
      rating: 4.8,
      reviews: 165,
      portfolio: [
        'https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=800&h=600&fit=crop&auto=format&q=80',
        'https://images.unsplash.com/photo-1583241478821-4c01f8c0e5e8?w=800&h=600&fit=crop&auto=format&q=80'
      ],
      specialties: ['Celebrity', 'Editorial', 'Bridal'],
      email: 'jessica.chen@beauty.com',
      phone: '+1 (555) 012-3456',
      bio: 'Renowned makeup artist with extensive experience working with celebrities and high-end editorial shoots.'
    }
  ],
  'Graphic Designers': [
    {
      id: 'graphic-1',
      name: 'Michael Chen',
      title: 'Creative Graphic Designer',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&auto=format&q=80',
      location: 'San Francisco, CA',
      experience: '8+ Years',
      rating: 4.8,
      reviews: 142,
      portfolio: [
        'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&h=600&fit=crop&auto=format&q=80',
        'https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?w=800&h=600&fit=crop&auto=format&q=80'
      ],
      specialties: ['Posters', 'Branding', 'Motion Graphics'],
      email: 'michael.chen@design.com',
      phone: '+1 (555) 123-4568',
      bio: 'Creative graphic designer specializing in visual branding, posters, and motion graphics for film and media.'
    },
    {
      id: 'graphic-2',
      name: 'Sophie Williams',
      title: 'Visual Design Specialist',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop&auto=format&q=80',
      location: 'Austin, TX',
      experience: '7+ Years',
      rating: 4.7,
      reviews: 98,
      portfolio: [
        'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&h=600&fit=crop&auto=format&q=80',
        'https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?w=800&h=600&fit=crop&auto=format&q=80'
      ],
      specialties: ['Title Design', 'Visual Effects', 'Digital Art'],
      email: 'sophie.williams@visual.com',
      phone: '+1 (555) 234-5679',
      bio: 'Innovative visual designer creating stunning title sequences and digital artwork for productions.'
    }
  ],
  'Directors': [
    {
      id: 'director-1',
      name: 'David Martinez',
      title: 'Film Director',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&auto=format&q=80',
      location: 'Los Angeles, CA',
      experience: '18+ Years',
      rating: 5.0,
      reviews: 76,
      portfolio: [
        'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&h=600&fit=crop&auto=format&q=80',
        'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800&h=600&fit=crop&auto=format&q=80'
      ],
      specialties: ['Feature Films', 'Commercials', 'Music Videos'],
      email: 'david.martinez@director.com',
      phone: '+1 (555) 345-6790',
      bio: 'Award-winning director with a passion for storytelling across feature films, commercials, and music videos.'
    },
    {
      id: 'director-2',
      name: 'Lisa Park',
      title: 'Commercial Director',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&auto=format&q=80',
      location: 'New York, NY',
      experience: '13+ Years',
      rating: 4.9,
      reviews: 112,
      portfolio: [
        'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&h=600&fit=crop&auto=format&q=80',
        'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800&h=600&fit=crop&auto=format&q=80'
      ],
      specialties: ['Brand Commercials', 'Digital Content', 'Corporate'],
      email: 'lisa.park@commercial.com',
      phone: '+1 (555) 456-7901',
      bio: 'Creative commercial director known for innovative brand storytelling and engaging digital content.'
    }
  ]
};
